import type { BadgeColors } from '@/lib/base/badges/badge-types';
import { Badge } from '@/lib/base/badges/badges';

import type { OrgSnowflakeDisplayStatus } from '../snowflake-types';

export interface SnowflakeStatusBadgeProps {
  status: OrgSnowflakeDisplayStatus;
}

const STATUS_BADGE_CONFIG: Record<
  SnowflakeStatusBadgeProps['status'],
  { label: string; color: BadgeColors }
> = {
  not_requested: { label: 'Not requested', color: 'gray' },
  pending: { label: 'Pending approval', color: 'warning' },
  approved: { label: 'Connected', color: 'success' },
  declined: { label: 'Declined', color: 'error' },
  revoked: { label: 'Revoked', color: 'error' },
  error: { label: 'Failed', color: 'error' },
  exists: { label: 'Already requested', color: 'gray' },
};

export function SnowflakeStatusBadge({ status }: SnowflakeStatusBadgeProps) {
  const { label, color } = STATUS_BADGE_CONFIG[status];

  return (
    <Badge type='color' size='sm' color={color}>
      {label}
    </Badge>
  );
}
